import React from 'react';
import { Menu } from 'antd/lib';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import CustomScrollbars from '../../util/CustomScrollbars';
import SidebarLogo from './SidebarLogo';
import UserProfile from './UserProfile';
import AppsNavigation from './AppsNavigation';
import { ThemeSetting } from '../../constants/ThemeSetting';
import IntlMessages from '../../util/IntlMessages';
import { toggleCollapsedSideNav } from '../../appRedux/actions';
import { onGetInboxEmployeePositionFolders } from '../../appRedux/actions';

const MenuItemGroup = Menu.ItemGroup;

const SidebarContent = () => {
  const { themeType, pathname, locale } = useSelector(
    ({ settings }: any) => settings,
  );

  const { navStyle, navCollapsed } = useSelector(({ sideNav }: any) => sideNav);

  const dispatch = useDispatch();
  const getNoHeaderClass = (navStyle: string) => {
    if (
      navStyle === ThemeSetting.NAV_STYLE_NO_HEADER_MINI_SIDEBAR ||
      navStyle === ThemeSetting.NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR
    ) {
      return 'gx-no-header-notifications';
    }
    return '';
  };

  const selectedKeys = pathname.substr(1);
  const defaultOpenKeys = selectedKeys.split('/')[1];

  return (
    <React.Fragment>
      <SidebarLogo />
      <div className="gx-sidebar-content gx-py-1">
        <div
          style={{ padding: '1px 1px 1px 1px', marginTop: '10px' }}
          dir={locale.direction}
          className={`gx-sidebar-notifications ${getNoHeaderClass(navStyle)}`}
        >
          <UserProfile
            direction={locale.direction as string}
            showUserName={navStyle !== ThemeSetting.NAV_STYLE_MINI_SIDEBAR}
          />
          <div className="gx-mt-1">
            <AppsNavigation />
          </div>
        </div>
        <CustomScrollbars className="gx-layout-sider-scrollbar">
          <Menu
            defaultOpenKeys={[defaultOpenKeys]}
            selectedKeys={[selectedKeys]}
            theme={
              themeType === ThemeSetting.THEME_TYPE_LITE ? 'light' : 'dark'
            }
            mode="inline"
          >
            <MenuItemGroup
              title={<IntlMessages id="sidebar.TeamWork" />}
              key="team-work"
              className="gx-menu-group"
            >
              <Menu.Item
                key="PWATreeMenuBuilder_teamWork"
                onClick={() => {
                  dispatch(toggleCollapsedSideNav(!navCollapsed));
                }}
                // className="gx-mx-2"
              >
                <Link to="/team-work/home" className="gx-d-flex">
                  <i className="icon icon-home gx-pt-1" />
                  <span className="gx-ml-1 gx-mr-1">
                    <IntlMessages id="sidebar.PWATreeMenuBuilder_Desktop" />
                  </span>
                </Link>
              </Menu.Item>
              <Menu.Item
                key="instance"
                onClick={() => {
                  dispatch(toggleCollapsedSideNav(!navCollapsed));
                  dispatch(onGetInboxEmployeePositionFolders(null));
                }}
                // className="gx-mx-2"
              >
                <Link
                  to="/team-work/instance?folder=Inbox-0"
                  className="gx-d-flex"
                >
                  <i className="icon icon-email gx-pt-1" />
                  <span className="gx-ml-1 gx-mr-1">
                    <IntlMessages id="sidebar.Cartable" />
                  </span>
                </Link>
              </Menu.Item>
              <Menu.Item
                key="dms"
                onClick={() => {
                  dispatch(toggleCollapsedSideNav(!navCollapsed));
                }}
              >
                <Link to="/team-work/dms?folder=dms-0" className="gx-d-flex">
                  <i className="icon icon-email gx-pt-1" />
                  <span className="gx-ml-1 gx-mr-1">
                    <IntlMessages id="sidebar.Dms" />
                  </span>
                </Link>
              </Menu.Item>
              <Menu.Item
                key="PWATreeMenuBuilder_News"
                onClick={() => {
                  dispatch(toggleCollapsedSideNav(!navCollapsed));
                }}
                // className="gx-mx-2"
              >
                <Link to="/team-work/news" className="gx-d-flex">
                  <i className="icon icon-alert gx-pt-1" />
                  <span className="gx-ml-1 gx-mr-1">
                    <IntlMessages id="sidebar.PWATreeMenuBuilder_News" />
                  </span>
                </Link>
              </Menu.Item>

              <Menu.Item
                key="chat"
                onClick={() => {
                  dispatch(toggleCollapsedSideNav(!navCollapsed));
                }}
                // className="gx-mx-2"
              >
                <Link to="/team-work/chat" className="gx-d-flex">
                  <i className="icon icon-chat-bubble gx-pt-1" />
                  <span className="gx-ml-1 gx-mr-1">
                    <IntlMessages id="sidebar.Messages" />
                  </span>
                </Link>
              </Menu.Item>
            </MenuItemGroup>

            <MenuItemGroup
              title={<IntlMessages id="sidebar.efficiency" />}
              key="letter"
              className="gx-menu-group"
            >
              <Menu.Item
                key="reminders"
                onClick={() => {
                  dispatch(toggleCollapsedSideNav(!navCollapsed));
                }}
              >
                <Link to="/efficiency/todo" className="gx-d-flex">
                  <i className="icon icon-check-square-o gx-pt-1" />
                  <span className="gx-ml-1 gx-mr-1">
                    <IntlMessages id="sidebar.todoApp" />
                  </span>
                </Link>
              </Menu.Item>

              <Menu.Item
                key="calendar"
                onClick={() => {
                  dispatch(toggleCollapsedSideNav(!navCollapsed));
                }}
                // className="gx-mx-2"
              >
                <Link to="/efficiency/calendar" className="gx-d-flex">
                  <i className="icon icon-calendar gx-pt-1" />
                  <span className="gx-ml-1 gx-mr-1">
                    <IntlMessages id="sidebar.Calendar" />
                  </span>
                </Link>
              </Menu.Item>

              <Menu.Item key="notes">
                <Link to="/efficiency/notes" className="gx-d-flex">
                  <i className="icon icon-copy gx-pt-1" />
                  <span className="gx-ml-1 gx-mr-1">
                    <IntlMessages id="sidebar.Note" />
                  </span>
                </Link>
              </Menu.Item>

              <Menu.Item
                onClick={() => {
                  dispatch(toggleCollapsedSideNav(!navCollapsed));
                }}
                key="contacts"
              >
                <Link to="/efficiency/contacts" className="gx-d-flex">
                  <i className="icon icon-compose gx-pt-1" />
                  <span className="gx-ml-1 gx-mr-1">
                    <IntlMessages id="sidebar.Contacts" />
                  </span>
                </Link>
              </Menu.Item>

              {window.location.origin === 'http://localhost:3000' && (
                <Menu.Item
                  onClick={() => {
                    dispatch(toggleCollapsedSideNav(!navCollapsed));
                  }}
                  key="test"
                >
                  <Link to="/dev-sanad-box/test" className="gx-d-flex">
                    <i className="icon icon-setting gx-pt-1 gx-text-primary" />
                    <span className="gx-ml-1 gx-mr-1">Test</span>
                  </Link>
                </Menu.Item>
              )}
            </MenuItemGroup>
          </Menu>
        </CustomScrollbars>
      </div>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {};
export default SidebarContent;
